import type { AnalyticsUser } from './types';

export enum HotJarTag {
  prefillPhoneFlow = 'Prefill Phone Flow',
  interstitial = 'Interstitial Enabled',
  seoWelcome = 'Seo Welcome',
  interstitialV2 = 'Interstitial v2 Enabled', // Remove it after v2 is fully launched
  predictCoverage = 'Predict Coverage Enabled',
  NewCarsDriversHideICon = 'New Cars Drivers Hide icon',
  HomeownerPreselectDisable = 'Homeowner Preselect disabled',
  HomeownerAskYesNo = 'Homeowner Yes/No',
  HomeownerOptions = 'Homeowner ownership options',
  AskViolationMobile = 'Ask Violation on Mobile',
  HomeOwnershipV3 = 'Home Ownership V3',
  MiddleName = 'Middle Name',
  DisplayAllQuotesInFinish = 'Display All Quotes In Finish',
  LoginChallenge = 'Login Challenge',
  LoginChallengeMatched = 'Login Challenge Matched',
  LoginChallengeNotMatched = 'Login Challenge Not Matched',
  PrefillQuotingInterstitial = 'Prefill Quoting Interstitial',
  PrefillQuotingInterstitialClick = 'Prefill Quoting Interstitial Click',
  PrefillQuotingInterstitialFakeQuotePrice = 'Prefill Quoting Interstitial Fake Quote Price',
  PrefillQuotingConfirmInformation = 'Prefill Quoting Confirm Information',
  PrefillQuotingSendCode = 'Prefill Quoting Send Code',
  UserEnterAddressManually = 'User Enter Address Manually',
  PrefillQuotingSwitchAccount = 'Prefill Quoting Switch Account',
  ConfirmInformation = 'Confirm Information',
  SplitConfirmInfo = 'Split Confirm Info',
  GeicoQuotesOnlyV2 = 'Geico Quotes Only V2',
  DriverNameVariation = 'Driver Name Variation',
  AddCarPages = 'Add Car Pages',
  AddDriverPages = 'Add Driver Pages',
  InsuranceFinishPage = 'Insurance Finish Page',
  InputIncorrectEmailDomainSuffix = 'Input Incorrect Email Domain Suffix',
}

/**
 * Identify user to Hotjar, tag recording according to user attribute.
 * @param user
 */
export const setUserForHJ = async (user: AnalyticsUser): Promise<void> => {
  if (typeof window !== 'undefined' && !!window.hj) {
    window.hj('identify', user.id, { user_id: user.id, isOnboardingLite: user.isOnboardingLite });
  }

  if (user.mlCoverageEnabled) {
    await tagHJ(HotJarTag.predictCoverage);
  }
};

/**
 * Tag Hotjar recording with passed in tagName param
 * @param tagName
 */
export const tagHJ = async (tagName: HotJarTag | string): Promise<void> => {
  if (typeof window === 'undefined' || !window.hj) {
    return;
  }
  window.hj('tagRecording', [tagName]);
};
